import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  DROPDOWN: `${cleanedFilename(__filename)}-dropdown`,
  TEXT_BUTTON: `${cleanedFilename(__filename)}-text-button`,
};
